import { default as axiosDefault } from 'axios';

const axiosInstance = axiosDefault.create();

let csrfToken = '';

const setCsrfToken = token => {
  csrfToken = token;
  axiosInstance.defaults.headers.common['X-CSRF-Token'] = token;
};

export const getCsrfToken = () => csrfToken;

const responseInterceptor = axiosInstance.interceptors.response.use(
  function(response) {
    const { data } = response;
    if (typeof data === 'string') return response;
    const { csrfToken, ...restData } = data;
    setCsrfToken(csrfToken);
    response.data = restData;
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

setCsrfToken(csrfToken);

const axios = axiosInstance;

export default axios;
